module.exports = __webpack_public_path__ + "static/media/237.6b3e1785.webp";